<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="8">
          <del-person-form
            :delagatedPerson="delagatedPerson"
            @emitData="updateDelagatedPerson"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DelPersonForm from "@/components/delagated-person/DelPersonForm";
import { mapState } from "vuex";

export default {
  components: {
    DelPersonForm,
  },
  data: () => ({}),
  computed: {
    ...mapState("DelPerson", ["delagatedPerson"]),
  },
  methods: {
    updateDelagatedPerson(payload) {
      console.log(payload);
      this.$store.dispatch("DelPerson/update", payload).then(() => {
        this.$router.push(`/delagated-person/${this.$route.params.patient_id}`);
      });
    },
  },
  created() {
    this.$store.dispatch("DelPerson/getEach", this.$route.params.patient_id);
  },
};
</script>
